import { DropdownOptionModel } from './dropdown-option-model';

export const PHONE_TYPE_OPTIONS: DropdownOptionModel<number>[] = [
  { value: 0, display: 'Home' },
  { value: 1, display: 'Mobile' },
  { value: 2, display: 'Work' }
];
